// extracted by mini-css-extract-plugin
module.exports = {"link":"_84acf41","iconContainer":"_c0ab72b","arrow":"_e08983f","icon":"_2266448"};